export class ProfileType {
    public static readonly GOLONGAN: number = 1;
    public static readonly PENDIDIKAN: number = 2;
    public static readonly JABATAN: number = 3;
    public static readonly PENINJAUAN_MASA_KERJA: number = 4;
    public static readonly PNS: number = 5;
    public static readonly DIKLAT: number = 6;
    public static readonly KELUARGA: number = 7;
    public static readonly SKP: number = 8;
    public static readonly PENGHARGAAN: number = 9;
    public static readonly ORGANISASI: number = 10;
    public static readonly CLTN: number = 11;
    public static readonly ANGKA_KREDIT: number = 12;
    public static readonly PROFESI: number = 13;
    public static readonly PINDAH_INSTANSI: number = 14;
    public static readonly KGB: number = 15;
    public static readonly BUP: number = 16;
    public static readonly SATYA_LENCANA: number = 17;
    public static readonly POSISI: number = 18;
    public static readonly KARIS_KARSU: number = 19;

    public static readonly GOLONGAN_TEXT: string = 'golongan';
    public static readonly PENDIDIKAN_TEXT: string = 'pendidikan';
    public static readonly JABATAN_TEXT: string = 'jabatan';
    public static readonly PENINJAUAN_MASA_KERJA_TEXT: string = 'pmk';
    public static readonly PNS_TEXT: string = 'pns';
    public static readonly DIKLAT_TEXT: string = 'diklat';
    public static readonly KELUARGA_TEXT: string = 'keluarga';
    public static readonly SKP_TEXT: string = 'skp';
    public static readonly PENGHARGAAN_TEXT: string = 'penghargaan';
    public static readonly ORGANISASI_TEXT: string = 'organisasi';
    public static readonly CLTN_TEXT: string = 'cltn';
    public static readonly ANGKA_KREDIT_TEXT: string = 'ak';
    public static readonly PROFESI_TEXT: string = 'profesi';
    public static readonly PINDAH_INSTANSI_TEXT: string = 'pindah-instansi';
    public static readonly KGB_TEXT: string = 'kgb';
    public static readonly BUP_TEXT: string = 'bup';
    public static readonly SATYA_LENCANA_TEXT: string = 'satya-lencana';
    public static readonly POSISI_TEXT: string = 'posisi';
    public static readonly KARIS_KARSU_TEXT: string = 'karis-karsu';
}